(function() {

    // header heart counter
    document.addEventListener("DOMContentLoaded", () => {
        document.body.addEventListener("initTheWishlist", () => {
            try {
                if (!window.theWishlist || !window.theWishlist.configStorefront || typeof window.theWishlist.countItemWishlist !== 'function') {
                    return;
                }
                const getCountItem = theWishlist.countItemWishlist();
                const elCountItemWishlist = document.querySelector('.wishlist__launch-point .count-item');
                if (elCountItemWishlist) {
                    if (getCountItem > 0) {
                        elCountItemWishlist.textContent = getCountItem;
                        elCountItemWishlist.style.opacity = '1';
                    } else {
                        elCountItemWishlist.style.opacity = '0';
                    }
                } else {
                    console.log('Element with the specified class not found.');
                }
            } catch (err) {
                console.warn('[TWC] Wishlist count could not be retrieved yet:', err);
            }
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
        function getVariantFromURL() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get("variant");
        }

        function updateBuyButtonsRow() {
            const variantId = getVariantFromURL();
            if (variantId) {
                document.querySelectorAll(".dynamic-variant-id").forEach((buttonRow) => {
                    buttonRow.setAttribute("data-variant-id", variantId);
                    //console.log("Updated .buy-buttons-row with variant ID:", variantId);
                });
            }
        }

        // Detect when the URL changes and update the variant ID
        function observeURLChanges() {
            let lastUrl = window.location.href;
            const observer = new MutationObserver(() => {
                if (window.location.href !== lastUrl) {
                    lastUrl = window.location.href;
                    updateBuyButtonsRow();
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }

        updateBuyButtonsRow();
        observeURLChanges();
    });

    document.addEventListener("DOMContentLoaded", function () {
        const TENANT_ID = "stfrock-au";
        console.log(TENANT_ID, "TWC init");
        const TOKEN_URL = `https://2hrfu2sis6cfjbslmkh6aslv7e0zpesc.lambda-url.ap-southeast-2.on.aws?tenant_id=${TENANT_ID}`;

        async function getAccessToken() {
            try {
                const response = await fetch(TOKEN_URL, { method: "POST" });
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const data = await response.json();
                return data.access_token;
            } catch (error) {
                console.error("Error fetching access token:", error);
                return null;
            }
        }

        // Function to inject the popup into the footer
        function injectPopup() {
            if (!document.querySelector("#popup-body")) {
            const _customerEmail = window.customerEmail || ''
                const popupHtml = `
                <div id="popup-body" class="overlay" style="display: none;">
                    <div id="popup-wrapper">
                        <h2 id="popup-title">Email me when available</h2>
                        <span id="popup-close">&times;</span>
                        <div id="popup-text">
                        Subscribe to be notified when this item is back in stock, or available to pre-order.
                        </div>
                        <div id="popup-message"></div>
                        <form id="popup-form">
                            <div class="custom-select">
                                <select name="select-size" required>
                                </select>
                            </div>
                            <input name="email" placeholder="Email" type="email" class="email" required value="${_customerEmail}">
                            <button type="submit" class="submit-notify email-sub-button subscribe-button">Email Me</button>
                            <div id="checkbox-wrapper"><input type="checkbox" name="mailList" id="mailList" checked><label for="mailList">Add to a mailing list</label></div>
                        </form>
                    </div>
                </div>`;
                document.body.insertAdjacentHTML("beforeend", popupHtml);
            }
        }

        // Function to fetch and populate out-of-stock variants
        function fetchAndPopulateVariants(productHandle, selectedVariantId) {
            const url = `/products/${productHandle}.js`;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(product => {
                    const selectElement = document.querySelector("#popup-body select[name='select-size']");
                    //selectElement.innerHTML = `<option value="">Select Size</option>`;

                    // Filter and display only out-of-stock variants
                    const outOfStockVariants = product.variants.filter(variant => !variant.available);

                    if (outOfStockVariants.length > 0) {
                        outOfStockVariants.forEach(variant => {
                            const option = document.createElement("option");
                            option.value = variant.id;
                            option.textContent = variant.title;

                            // Pre-select the variant if it matches
                            if (variant.id.toString() === selectedVariantId) {
                            option.selected = true;
                            }

                            selectElement.appendChild(option);
                        });
                    } else {
                        selectElement.innerHTML = `<option value="">No out-of-stock sizes</option>`;
                    }

                    const popup = document.querySelector('#popup-body');
                    popup.style.display = "flex";
                    popup.classList.add('active');
                })
                .catch(error => console.error("Error fetching product variants:", error));
        }

        // Function to open the popup
        function openPopup(productHandle, selectedVariantId) {
            fetchAndPopulateVariants(productHandle, selectedVariantId);
        }

        // Function to close the popup and clear the form
        function closePopup() {
            const popup = document.querySelector("#popup-body");
            if (!popup) return;

            const form = popup.querySelector("#popup-form");
            const selectElement = form.querySelector("select[name='select-size']");
            const emailInput = form.querySelector("input[name='email']");
            const popupMessage = document.querySelector("#popup-message");

            // Reset form fields
            if (selectElement) {
                selectElement.innerHTML = ""; // Clear previous options
            }

            popupMessage.innerText = "";

            // Show form again if hidden
            form.style.display = "flex";

            // Hide and remove popup
            popup.style.display = "none";
            popup.classList.remove("active");
        }

        function getProductHandle(button) {
            const productUrl = button.getAttribute("data-du") ||
                button.closest("oos-button")?.getAttribute("data-url") ||
                button.closest("product-block")?.querySelector("[data-du]")?.getAttribute("data-du");

            if (button.getAttribute("data-handle")) {
                return button.getAttribute("data-handle");
            }

            if (!productUrl) return null;

            try {
                const pathname = new URL(productUrl, window.location.origin).pathname;
                return pathname.match(/\/products\/([^/?#]+)/)?.[1] || null;
            } catch (error) {
                console.error("Unable to read product handle from URL:", productUrl, error);
                return null;
            }
        }

        // Attach event listeners to notify controls. `root` allows Searchspring
        // recommendations to be initialised as soon as they are rendered.
        function attachButtonListeners(root = document) {
            const selector = ".twc-notifyme, .ss__oos_button";
            const notifyButtons = [];

            if (root instanceof Element && root.matches(selector)) {
                notifyButtons.push(root);
            }
            notifyButtons.push(...root.querySelectorAll(selector));

            notifyButtons.forEach(button => {
                if (button.classList.contains("product-block-options__item") &&
                    !button.classList.contains("product-block-options__item--unavailable") &&
                    !button.classList.contains("product-block__button__notify-me") &&
                    !button.classList.contains("swym-custom-watchlist")) {
                    return;
                }
                if (button.dataset.twcNotifyInitialised === "true") return;

                button.dataset.twcNotifyInitialised = "true";
                button.addEventListener("click", function () {
                    const productHandle = getProductHandle(button);
                    const selectedVariantId = button.getAttribute("data-variant-id") ||
                        button.getAttribute("data-epi") || "";

                    if (productHandle) {
                        openPopup(productHandle, selectedVariantId);
                    } else {
                        console.error("No product handle found on button:", button);
                    }
                });
            });
        }

        // Close popup when the close button is clicked
        document.body.addEventListener("click", function (event) {
            if (event.target.id === "popup-close") {
                closePopup();
            }
        });

        // Close popup when clicking outside the popup wrapper
        document.body.addEventListener("click", function (event) {
            const popupWrapper = document.querySelector("#popup-wrapper");
            if (popupWrapper && !popupWrapper.contains(event.target) && event.target.closest("#popup-body")) {
                closePopup();
            }
        });

        // Handle form submission
        document.body.addEventListener("submit", async function (event) {
            if (event.target.id === "popup-form") {
                event.preventDefault();
                const form = event.target;
                const popupMessage = document.querySelector("#popup-message");
                popupMessage.innerText = "";

                let formData = {
                    email: form.querySelector("input[name='email']").value,
                    variantRef: form.querySelector("select[name='select-size']").value,
                    notifyMe: true
                };

                const ACCESS_TOKEN = await getAccessToken();

                console.log("Form Data:", JSON.stringify(formData, null, 2));

                // Submit the form data to API
                let url = `https://api.au-aws.thewishlist.io/services/wsservice/api/wishlist/items/customerInterest`;

                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        Authorization: "Bearer " + ACCESS_TOKEN,
                        "X-Twc-Tenant": TENANT_ID,
                    },
                    body: JSON.stringify(formData),
                })
                    .then((response) => {
                        if (!response.ok) {
                            return response.text().then((text) => {
                                throw new Error(`Server Error: ${text}`);
                            });
                        }
                        return response.json();
                    })
                    .then((data) => {
                        console.log("API Response Data:", data);
                        popupMessage.innerText = "Awesome, we'll keep you informed with the latest updates.";
                        popupMessage.style.opacity = 1;
                        form.style.display = 'none';
                        setTimeout(closePopup, 3000);
                    })
                    .catch((error) => {
                        console.error("Error submitting form:", error);
                        if (error.message.includes("is already exists")) {
                            popupMessage.innerText = "You have already subscribed for this product.";
                        } else {
                            popupMessage.innerText = "Form submission failed: " + error.message;
                        }
                        popupMessage.style.opacity = 1;
                        setTimeout(closePopup, 3000);
                    });
            }
        });

        // Initialize the popup and event listeners
        injectPopup();
        attachButtonListeners();

        window.addEventListener("searchspring.dom", function (e) {
            const root = e.detail?.root || document;
            attachButtonListeners(root);
            if (hasUninitializedWishlist(root)) {
                scheduleWishlistRescan();
            }
        });

        // TheWishlist app renders SVG icons into .button-icon inside .button-collection-wishlist.
        // In Searchspring recommendations, tiles are injected dynamically without icons.
        // Dispatching "initTheWishlist" triggers TheWishlist app to scan and initialize them.
        // NOTE: TheWishlist app clones and replaceChild's each button during init, which triggers
        // MutationObserver. To prevent an infinite loop, only schedule a rescan if at least one
        // button has NOT been initialized yet (i.e. lacks an SVG icon).
        let wishlistRescanHandle = null;
        function scheduleWishlistRescan() {
            clearTimeout(wishlistRescanHandle);
            wishlistRescanHandle = setTimeout(function () {
                wishlistRescanHandle = null;
                document.body.dispatchEvent(new CustomEvent("initTheWishlist"));
            }, 150);
        }

        function hasUninitializedWishlist(node) {
            if (!(node instanceof Element)) return false;
            const buttons = [];
            if (node.matches(".button-collection-wishlist")) {
                buttons.push(node);
            }
            const queried = node.querySelectorAll(".button-collection-wishlist");
            for (let i = 0; i < queried.length; i++) {
                buttons.push(queried[i]);
            }
            return buttons.some((btn) => !btn.querySelector(".button-icon svg, svg"));
        }

        // Searchspring recommendations are rendered after DOMContentLoaded.
        // Observe additions so both desktop and mobile controls are initialised,
        // without rebinding the controls that already work on the main PDP.
        const recommendationsObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof Element)) return;
                    if (node.matches(".ss__oos_button, .twc-notifyme") ||
                        node.querySelector(".ss__oos_button, .twc-notifyme, wishlist-button")) {
                        attachButtonListeners(node);
                    }
                    if (hasUninitializedWishlist(node)) {
                        scheduleWishlistRescan();
                    }
                });
            });
        });

        recommendationsObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
        function preselectVariant() {
            let selectedValue = null;

            // Collect all active elements from both selectors
            const activeLinks = document.querySelectorAll("ul.clickyboxes li a.active");
            const activeOptions = document.querySelectorAll(".product-block-options__inner .product-block-options__item--active");

            // Iterate through active links to find the first valid value
            activeLinks.forEach((link) => {
                if (!selectedValue) {
                    selectedValue = link.dataset.value || link.textContent.trim();
                }
            });

            // Iterate through active options if no value is found
            activeOptions.forEach((option) => {
                if (!selectedValue) {
                    selectedValue = option.dataset.value || option.textContent.trim();
                }
            });

            if (!selectedValue) {
                console.log("No active variant found.");
                return;
            }

            console.log("Selected Variant Value:", selectedValue);

            // Wait for the modal to open
            const checkModalInterval = setInterval(function () {
                const modal = document.querySelector(".modal-root.osc-css.open");
                if (modal) {
                    clearInterval(checkModalInterval);
                    console.log("Modal detected as open!");

                    let attempts = 0;
                    const checkVariantInterval = setInterval(() => {
                        const variantInput = document.querySelector(`.modal-root.osc-css.open .variant-item-input[value="${selectedValue}"]`);

                        if (variantInput) {
                            clearInterval(checkVariantInterval);
                            variantInput.checked = true;
                            variantInput.dispatchEvent(new Event("change", { bubbles: true }));
                            console.log("Pre-selected variant:", selectedValue);
                        } else {
                            console.log("Matching variant input not found:", selectedValue);
                            if (attempts >= 10) clearInterval(checkVariantInterval); // Stop after 10 attempts
                        }
                        attempts++;
                    }, 100);
                }
            }, 50);
        }

        // Attach click event to the wishlist button
        document.querySelectorAll(".wrapper-button-collection").forEach((button) => {
            button.addEventListener("click", function () {
                console.log("Wishlist button clicked, checking for modal...");
                preselectVariant();
            });
        });
    });

})();
